export default "__VITE_ASSET__CEsT6U_O__"